<template>
  <div class="sort_produce flx">
    <span class="desctop_v">Сортировать по:</span>
    <select name="sort_by" v-model="selected" @change="selectItem">
      <option :value="item.value + '_' + item.direction" v-for="item in items" :key="item.value + '_' + item.direction">{{ item.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ItemsSortBy',
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            name: 'По новинкам',
            value: 'created',
            direction: 'desc'
          },
          {
            name: 'От дешевых',
            value: 'price',
            direction: 'asc'
          },
          {
            name: 'От дорогих',
            value: 'price',
            direction: 'desc'
          }
        ]
      }
    },
    sortBy: {
      type: String,
      default: 'created'
    },
    sortDirection: {
      type: String,
      default: 'desc'
    }
  },
  data () {
    return {
      selected: 'created_desc'
    }
  },
  methods: {
    selectItem (e) {
      const values = e.target.value.split('_')
      this.$emit('update:sortBy', values[0])
      this.$emit('update:sortDirection', values[1])
    }
  }
}
</script>

<style scoped>

</style>
